//@flow

import React from 'react';
import { camelizeKeys } from 'humps';
import { AsyncTypeahead, Menu, MenuItem } from 'react-bootstrap-typeahead';

import api from '../../../lib/api';
import { useSetState } from '../../../hooks';
import { constructLabel } from '../helpers';

const INITIAL_STATE = {
  searchQueryResults: [],
  loading: false,
};

type Props = {
  onItemClick: (data: any) => void,
  defaultValue: any,
};

export default function InputSearchQuery(props: Props) {
  const [{ loading, searchQueryResults }, setState] = useSetState(INITIAL_STATE);

  async function handleSearch(searchTerm) {
    setState({ loading: true });
    try {
      const { data } = await api.get(`search/?q=${searchTerm}`);
      setState({ searchQueryResults: camelizeKeys(data) });
    } finally {
      setState({ loading: false });
    }
  }

  const { defaultValue, onItemClick } = props;

  return (
    <AsyncTypeahead
      labelKey={constructLabel}
      placeholder="Where do you want to go?"
      options={searchQueryResults}
      onSearch={handleSearch}
      isLoading={loading}
      selected={defaultValue ? [defaultValue] : []}
      onChange={onItemClick}
      renderMenu={(results, menuProps) => {
        return (
          <Menu {...menuProps}>
            {results.map((result, index) => (
              <MenuItem option={result} position={index} key={index}>
                {constructLabel(result)}
              </MenuItem>
            ))}
          </Menu>
        );
      }}
    />
  );
}



// WEBPACK FOOTER //
// ./src/screens/Lodge/Common/InputSearchQuery.js